<div class="flex items-center justify-between px-1">
  <h3
    class="text-lg sm:text-xl font-bold text-[#1E293B] dark:text-white font-['Merriweather']"
  >
    {{ title() }}
  </h3>
  @if (linkLabel()) {
  <span
    class="text-sm font-medium text-slate-500 dark:text-slate-300 cursor-pointer hover:text-primary transition-colors"
    (click)="linkClicked.emit()"
    (keyup.enter)="linkClicked.emit()"
    (keyup.space)="linkClicked.emit()"
    tabindex="0"
    role="button"
    >{{ linkLabel() }}</span
  >
  }
</div>
